import axios from 'axios';

import type {
  IUserVerifyEmailQuery,
  IUserVerifyEmailRequest,
  IUserVerifyEmailResponse,
} from '@/app-package';

const verifyEmail = async (params: IUserVerifyEmailQuery) => {
  const { email, userId } = params;
  const searchParams = new URLSearchParams();
  searchParams.set('email', email);
  if (userId) searchParams.set('userId', userId);
  const url = `/user/verify/email?${searchParams}`;

  const config: IUserVerifyEmailRequest = { url, method: 'get' };

  const { data } = await axios.request<IUserVerifyEmailResponse>(config);

  return data;
};

export default verifyEmail;
